module.exports = __webpack_public_path__ + "media/college_scholarships/how-fastweb-works-f428e8ac.png";